module.exports = __webpack_public_path__ + "static/media/p-3.30bc8fbe.jpg";